import { Component } from 'nuxt-property-decorator'
import { IBusiness, BusinessBase } from '~/components/setion/experience/base/business-base'

@Component
export default class TourBusinessBase extends BusinessBase implements IBusiness {
  getDataFail() {
    this.hideSection && this.hideSection()
  }
}
